(function() {
    'use strict';

    angular
        .module('setupApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','GLOBAL_URL'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('accdisabled', {
            url: '/accdisabled',
            data: {
                pageTitle: 'Tài khoản mất hiệu lực'
            },
            views: {
                'content@': {
                    templateUrl: GLOBAL_URL+'partial?uri=ga/setup/accdisabled/layouts/accdisabled',
                    controller: 'AccDisabledController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        });
    }

})();
